import cuid from 'cuid'
import React, { useEffect, useRef } from 'react'

export interface IconPremiumProps {
    title?: string
    className?: string
    fill?: string
    backgroundFill?: string
}

export const IconPremium: React.FC<IconPremiumProps> = ({
    title,
    className,
    fill = '#043DE2',
    backgroundFill = 'white',
}) => {
    // TODO: Replace with `React.useId` in React 18
    const baseId = useUniqueIdOnMount('ico-prem')
    const clipPathId = `clip-${baseId}`

    return (
        <svg
            viewBox="0 0 260 260"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            role="img"
        >
            <title>{title || 'Premium'}</title>
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d="M195 139.286C195 134.158 190.843 130 185.714 130H74.2857C69.1574 130 65 134.158 65 139.286V195C65 200.129 69.1574 204.286 74.2857 204.286H185.714C190.843 204.286 195 200.129 195 195V139.286ZM120.714 176.429V157.857C120.714 152.729 124.872 148.572 130 148.572C135.128 148.572 139.286 152.729 139.286 157.857V176.429C139.286 181.557 135.128 185.714 130 185.714C124.872 185.714 120.714 181.557 120.714 176.429ZM157.857 83.5716C157.857 68.1866 145.385 55.7145 130 55.7145C114.615 55.7145 102.143 68.1866 102.143 83.5716V111.429H157.857V83.5716ZM176.429 111.429H185.714C201.099 111.429 213.571 123.901 213.571 139.286V195C213.571 210.385 201.099 222.857 185.714 222.857H74.2857C58.9007 222.857 46.4286 210.385 46.4286 195V139.286C46.4286 123.901 58.9007 111.429 74.2857 111.429H83.5714V83.5716C83.5714 57.9298 104.358 37.1431 130 37.1431C155.642 37.1431 176.429 57.9298 176.429 83.5716V111.429Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect
                        width="222.857"
                        height="222.857"
                        fill={backgroundFill}
                        transform="translate(18.5714 18.5715)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

const useUniqueIdOnMount = (initialId: string) => {
    const mounted = useRef(false)

    useEffect(() => {
        mounted.current = true
    }, [])

    return mounted.current ? cuid.slug() : initialId
}
